import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { API_URL_V4 } from 'src/environments/environment.local';
import * as filterHelpers from '../helpers/filter.helpers';
import * as sortingHelpers from '../helpers/sorting.helpers';
import { BrowseFilter } from '../models/filter';
import { BrowseSorting } from '../models/sorting';
import { Sport } from '../models/sport';
import { ApiHttpResponse, GpsOnly } from '@kinomap-dev/ng-ui-lib';

@Injectable({ providedIn: 'root' })
export class GpsApi {
  private readonly gpsUrl: string = `${API_URL_V4}/mapmode`;
  private readonly limit: number = 15;
  private lastSelectedSport: Sport | null = null;
  private lastFilters: BrowseFilter[] = [];
  private lastSorting: BrowseSorting | null = null;
  private params: HttpParams = new HttpParams();
  isLastPageLoaded: boolean = false;

  constructor(private http: HttpClient) {
    this.params = this.params.set('limit', this.limit).set('page', 1);
  }

  getGpsTracks$(
    selectedSport: Sport = this.lastSelectedSport,
    filters: BrowseFilter[] = this.lastFilters,
    sorting: BrowseSorting = this.lastSorting,
    nextPage: boolean
  ): Observable<GpsOnly[]> {
    this.params = this.params
      .set('sport', selectedSport.name)
      .set('sortDirection', filterHelpers.getSortDirectionParam(filters))
      .set('sortType', sortingHelpers.getSortTypeParam(sorting));
    this.setFilterParams(filters);

    if (!nextPage) {
      this.params = this.params.set('page', 1);
      this.isLastPageLoaded = false;
    }

    return this.http
      .get<ApiHttpResponse<GpsOnly[]>>(this.gpsUrl, { params: this.params })
      .pipe(
        map((res: ApiHttpResponse<GpsOnly[]>) => {
          const currentPage: number = +res.meta.current_page;
          const lastPage: number = +res.meta.last_page;

          if (currentPage === lastPage) {
            this.isLastPageLoaded = true;
          } else {
            this.params = this.params.set('page', currentPage + 1);
          }

          this.lastSelectedSport = { ...selectedSport };
          this.lastFilters = [
            ...filters.map((f: BrowseFilter) => {
              return { ...f };
            }),
          ];
          this.lastSorting = { ...sorting };

          return res.data;
        })
      );
  }

  private setFilterParams(filters: BrowseFilter[]): void {
    this.setDistanceParams(filters);
    this.setSlopeParams(filters);
  }

  private setDistanceParams(filters: BrowseFilter[]): void {
    const [min, max]: string[] = filterHelpers.getDistanceParams(filters);
    this.params = this.params.set('minDistance', min).set('maxDistance', max);
  }

  private setSlopeParams(filters: BrowseFilter[]): void {
    const [min, max]: string[] = filterHelpers.getSlopeParams(filters);
    this.params = this.params
      .set('minPositiveSlope', min)
      .set('maxPositiveSlope', max);
  }
}
